import type { TypedTypePolicies } from 'types/gql/apollo-helpers'

/** Cache NavigationItem directly under the Store (with storeId as its key) */
export const NavigationItem: NonNullable<TypedTypePolicies['NavigationItem']> = {
  keyFields: false,
}
